export default __webpack_public_path__ + "static/media/drop_gray.2bcd95da.svg";